import { useEffect, useState } from 'react';

function defaultNotification() {
  if (!('Notification' in window)) {
    return 'default';
  }
  return Notification.permission;
}

export function useNotificationPermission() {
  const [permission, setPermission] = useState(defaultNotification());

  useEffect(() => {
    async function askPermission() {
      const result = await Notification.requestPermission();
      setPermission(result);
      console.debug(`Notification permission: ${result}`);
    }
    if (!('Notification' in window)) {
      console.warn('This browser does not support notifications.');
      return;
    }
    if (Notification.permission === 'default') {
      void askPermission();
    }
  }, []);

  return permission;
}
